import { useEffect, useRef, useContext } from 'react'
import { useColorScheme } from '@mui/material'
import { MapRenderContext } from 'src/contexts/MapRenderContext'
import { setupMap, getMapStyle } from 'src/components/map/Map'

export function useMapTheme() {
    const { mode } = useColorScheme()
    const { map, setMapLoaded } = useContext(MapRenderContext)
    const initialMounted = useRef(false)

    useEffect(() => {
        if (!mode || !map?.current) return

        if (!initialMounted.current) {
            initialMounted.current = true
            return
        }

        setMapLoaded(false)

        const style = getMapStyle()
        map.current.once('style.load', () => {
            if (!map.current) return
            setupMap(map.current)
            setMapLoaded(true)
        })

        map.current.setStyle(style)
    }, [mode, map, setMapLoaded])
}
